'use client';
import { useCallback, useMemo } from 'react';
const useFileUpload = (onError, onRead, mimeTypes = [], maxSize = 4194304) => {
    const onDrop = useCallback((files) => {
        for (const file of files) {
            if (file.size > maxSize)
                return onError('FILE_SIZE_TOO_LARGE');
            const reader = new window.FileReader();
            reader.addEventListener('error', () => onError('ERROR'));
            reader.readAsDataURL(file);
            reader.onloadend = (readerEvent) => onRead(readerEvent.target.result, file.name, file.type);
        }
    }, [onError, onRead, maxSize]);
    const accept = useMemo(() => mimeTypes.reduce((acc, cur) => (Object.assign(Object.assign({}, acc), { [cur]: [] })), {}), [mimeTypes]);
    return { onDrop, accept };
};
export default useFileUpload;
//# sourceMappingURL=fileUpload.js.map